import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { validateUser } from 'utils/functions/authentication';
import AuthenticationPage from 'pages/AuthenticationPage';

const PrivateRoute = () => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null);

  useEffect(() => {
    validateUser(true).then(result => {
      const { isValidUser } = result;
      setIsUserAuthenticated(isValidUser);
    });
  }, []);

  if (isUserAuthenticated === true) return <Outlet />;

  if (isUserAuthenticated === false) return <Navigate to="/login" />;

  return <AuthenticationPage />;
};

export default PrivateRoute;
